import React from 'react';
import { formatOptionBadge } from '../utils/formatting';

/**
 * Color mapping for booking option badges.
 */
const BADGE_COLORS = {
  'No camel': '#f97316',
  'No quad': '#a855f7',
  'Swimming': '#3b82f6',
  'Ticket Swimming': '#06b6d4',
};

/**
 * BookingOptionBadge renders a colored badge for a booking option.
 * Shows quantity prefix when quantity > 1 (e.g., "2 × Ticket Swimming").
 *
 * @param {{ option: { label: string, quantity: number } }} props
 */
function BookingOptionBadge({ option }) {
  if (!option || !option.label) {
    return null;
  }

  const text = formatOptionBadge(option);
  const color = BADGE_COLORS[option.label] || '#6b7280';

  const style = {
    display: 'inline-block',
    backgroundColor: color,
    color: '#fff',
    fontSize: '0.75rem',
    fontWeight: 600,
    padding: '2px 8px',
    borderRadius: '9999px',
    marginRight: '4px',
    marginBottom: '4px',
    whiteSpace: 'nowrap',
  };

  return <span style={style}>{text}</span>;
}

export default BookingOptionBadge;
